module.exports = __webpack_public_path__ + "static/coach-hire-services-group-tours-61b436b563b96dcff7ee3fde3edb64ab.jpg";